import { ParcelStatus } from "@/models/ParcelStatus";

/**
 * The API derives a parcel's status from its tracking timestamps, so this maps
 * those values onto the labels we already have. Statuses outside this map -
 * the StarLinks workflow states - fall back to their raw value rather than
 * being forced into a tracking status they do not represent.
 */
export const PARCEL_STATUS_LABELS: Record<string, string> = {
  [ParcelStatus.DELIVERED]: "general.delivered",
  [ParcelStatus.RETURNED]: "general.returned",
  [ParcelStatus.IN_TRANSIT]: "general.in_transit",
  information_received: "general.accepted",
  [ParcelStatus.CREATED]: "general.created",
};
